import { render } from "./VorsorgeaufstellungenListe.vue?vue&type=template&id=a3f530ec"
import script from "./VorsorgeaufstellungenListe.vue?vue&type=script&lang=js"
export * from "./VorsorgeaufstellungenListe.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__